var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root-skeleton",class:{circle: _vm.circle, fill: _vm.fill},style:({
    '--animation-duration': `${_vm.duration}s`,
    '--animation-delay': `${_vm.delay}s`
  })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }